type CheckBookingModal = CheckBookingModalEnum | `${CheckBookingModalEnum}`;

export enum CheckBookingModalEnum {
	VERIFYING_DUPLICITY = 'verifyingDuplicity',
	VERIFYING_AUTH = 'verifyingAuth',
	VERIFYING_DISTRICTS = 'verifyingDistricts',
	VERIFYING_REQUEST_SCHEDULE = 'verifyingRequestSchedule',
	ERROR = 'error',
	DUPLICITY_STATE = 'duplicityState',
	NEED_AUTH = 'needAuth',
	SCRIPT_STATE = 'scriptState',
	NONE = 'none',
}

interface UseOdontoSpecialtySelectionProps {
	handleNextStep: () => void;
}

export type {UseOdontoSpecialtySelectionProps, CheckBookingModal};
